import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import Select from 'util/modules/Form/Select'

import { inputMaskMoney } from 'util/masks'
import { ApplicationState } from 'AppReducer'
import { ProductSectionItem } from 'panel/partner/product-config/redux/types'
import { deleteSectionItem, updateSectionItem } from 'panel/partner/product-config/redux/actions/section-item'

const initialState = {
  isActive: true, pProd: 0, min: 0, max: 0, price: 0, alias: '', priceFormated: 'R$ 0,00'
}

type ComponentOpts = { sectionId: number, item: ProductSectionItem }
const ProductSectionItemComponent: React.FC<ComponentOpts> = ({ sectionId, item }) => {
  const dispatch = useDispatch()

  const { id: productId } = useParams<{ id: string }>()

  const [form, setForm] = useState(initialState)
  const [isFetching, setFetching] = useState(false)

  const { product, products } = useSelector((state: ApplicationState) => state.partnerProductReducer)
  const partnerId = product?.partner.id

  function handleUpdate (pProd?: number): void {
    if (partnerId && productId && item.id) {
      setFetching(true)
      const data = { ...form, pProd: pProd || form.pProd }
      updateSectionItem(partnerId, productId, sectionId, item.id, data)(dispatch).then(() => {
        setFetching(false)
      })
    }
  }

  function handleRemove (): void {
    if (partnerId && productId && item.id && window.confirm('Tem certeza que deseja remover?')) {
      deleteSectionItem(partnerId, productId, sectionId, item.id)(dispatch)
    }
  }

  useEffect(() => {
    setForm({
      isActive: !!item.isActive,
      pProd: item.pProd?.id || 0,
      min: item.min || 0,
      max: item.max || 0,
      price: item.price || 0,
      alias: item.alias || '',
      priceFormated: inputMaskMoney(item.price || 0, 'R$')[0]
    })
  }, [item])

  if (!partnerId) return null

  const gridTemplateColumns = '50px 100px  2fr 1fr 100px 60px 60px'

  return (
    <>
      <div className="row align-end">
        <div className="grow align-end" style={{ display: 'grid', gridTemplateColumns }}>
          <div className="form-control" style={{ alignContent: 'space-between', height: 83 }}>
            <label>Img</label>
            <img
              alt=""
              className="col-12 border-radius"
              src={item.pProd?.product?.pictureTiny || `${process.env.PUBLIC_URL}/img/default-img.png`}
            />
          </div>

          <div className="form-control">
            <label>Ativo?</label>
            <select
              value={form.isActive ? 1 : 0}
              onChange={(e): void => setForm({ ...form, isActive: parseInt(e.target.value) === 1 })}
            >
              <option value={1}>Sim</option>
              <option value={0}>Não</option>
            </select>
          </div>
          <div className="form-control">
            <label>Produto</label>
            <Select
              selected={form.pProd}
              onSelect={(pProd): void => {
                setForm({ ...form, pProd })
                handleUpdate(pProd)
              }}
              itens={products.items.map(item => ({ key: item.id, value: item.product?.name }))}
              required
            />
          </div>
          <div className="form-control">
            <label>Tag</label>
            <input
              type="text"
              value={form.alias}
              onChange={(e): void => setForm({ ...form, alias: e.target.value })}
            />
          </div>
          <div className="form-control">
            <label>Preço</label>
            <input
              type="text"
              value={form.priceFormated}
              onChange={(e): void => {
                const [priceFormated, price] = inputMaskMoney(e.target.value, 'R$')
                setForm({ ...form, priceFormated, price })
              }}
            />
          </div>
          <div className="form-control">
            <label>Mín</label>
            <input
              type="number"
              value={form.min}
              step={1}
              onChange={(e): void => setForm({ ...form, min: parseInt(e.target.value) })}
            />
          </div>
          <div className="form-control">
            <label>Máx</label>
            <input
              type="number"
              value={form.max}
              step={1}
              onChange={(e): void => setForm({ ...form, max: parseInt(e.target.value) })}
            />
          </div>
        </div>

        <span className="button remove margin-left-8" onClick={handleRemove} style={{ width: 48 }}>
          <i className="fas fa-trash" style={{ margin: 0 }} />
        </span>
        {
          isFetching
            ? (
              <span className="button primary margin-left-8" style={{ width: 130 }}>
                <i className="fas fa-spinner fa-spin" /> Aguarde...
              </span>
            )
            : (
              <span className="button primary margin-left-8" onClick={() => handleUpdate()} style={{ width: 130 }}>
                <i className="fas fa-save" /> Salvar
              </span>
            )
        }
      </div>
    </>
  )
}

export default ProductSectionItemComponent
